
namespace RioERP.Orders {

    @Serenity.Decorators.registerClass()
    export class OrderBookDialog extends Serenity.EntityDialog<OrderBookRow, any> {
        protected getFormKey() { return OrderBookForm.formKey; }
        protected getIdProperty() { return OrderBookRow.idProperty; }
        protected getLocalTextPrefix() { return OrderBookRow.localTextPrefix; }
        protected getService() { return OrderBookService.baseUrl; }
        protected getDeletePermission() { return OrderBookRow.deletePermission; }
        protected getInsertPermission() { return OrderBookRow.insertPermission; }
        protected getUpdatePermission() { return OrderBookRow.updatePermission; }

        protected form = new OrderBookForm(this.idPrefix);
        updateInterface() {
            super.updateInterface();
            Serenity.EditorUtils.setReadOnly(this.form.OrderId, true);
        }
    }
}